import React from "react";
import { Button, Modal } from "react-bootstrap";

export default function Popup({ show, onHide, title, body }) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant="danger">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
